<template>
    <div>
        <utilities-electricity
            class="mb-6"
            :commercial="commercial"
            :read_only="read_only"
        />

        <utilities-gas
            class="mb-6"
            :commercial="commercial"
            :read_only="read_only"
        />

        <utilities-heating
            class="mb-6"
            :commercial="commercial"
            :read_only="read_only"
        />

        <utilities-cooling
            class="mb-6"
            :commercial="commercial"
            :read_only="read_only"
        />

        <utilities-water
            class="mb-6"
            :commercial="commercial"
            :read_only="read_only"
        />

        <utilities-wastewater
            class="mb-6"
            :commercial="commercial"
            :read_only="read_only"
        />

        <utilities-lawn
            class="mb-6"
            :commercial="commercial"
            :read_only="read_only"
        />

        <utilities-filtration-pond
            class="mb-6"
            :commercial="commercial"
            :read_only="read_only"
        />

        <utilities-detention-pond
            class="mb-6"
            :commercial="commercial"
            :read_only="read_only"
        />

        <utilities-drainage
            class="mb-6"
            :commercial="commercial"
            :read_only="read_only"
        />

        <utilities-security
            :commercial="commercial"
            :read_only="read_only"
        />

        <utilities-notes
            :commercial="commercial"
            :read_only="read_only"
        />
    </div>
</template>

<script>
import UtilitiesElectricity from './utilities-electricity.vue';
import UtilitiesGas from './utilities-gas.vue';
import UtilitiesHeating from './utilities-heating.vue';
import UtilitiesCooling from './utilities-cooling.vue';
import UtilitiesWater from './utilities-water.vue';
import UtilitiesWastewater from './utilities-wastewater.vue';
import UtilitiesLawn from './utilities-lawn.vue';
import UtilitiesFiltrationPond from './utilities-filtration-pond.vue';
import UtilitiesDetentionPond from './utilities-detention-pond.vue';
import UtilitiesSecurity from './utilities-security.vue';
import UtilitiesDrainage from './utilities-drainage.vue';
import UtilitiesNotes from './utilities-notes.vue';

export default {
    components: {
        UtilitiesElectricity,
        UtilitiesGas,
        UtilitiesHeating,
        UtilitiesCooling,
        UtilitiesWater,
        UtilitiesWastewater,
        UtilitiesLawn,
        UtilitiesFiltrationPond,
        UtilitiesDetentionPond,
        UtilitiesSecurity,
        UtilitiesDrainage,
        UtilitiesNotes,
    },

    props: {
        commercial: {},
        read_only: { default: false },
    },
}
</script>
